import React, { Component } from "react";
import { MdArrowUpward, MdFilterList } from "react-icons/md";
import { connect } from "react-redux";
import { animateScroll as scroll } from "react-scroll";
import { Button, Nav, NavItem } from "reactstrap";
import { NavbarWithHeight } from "../NavbarWithHeight";

interface Props {
  toggleCollapse: () => void;
}
class NavbarSecond extends Component<
  Props,
  { dropdownOpen: boolean; isOpen: boolean }
> {
  constructor(props: Props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = { dropdownOpen: false, isOpen: false };
  }
  public toggleDropdown() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
  public scrollToTop() {
    scroll.scrollToTop({ duration: 500, smooth: true });
  }
  public render() {
    return (
      <NavbarWithHeight color="dark" dark={true}>
        <Nav className="navbar-nav">
          <NavItem className="nav-item" style={{ display: "inline-block" }}>
            <Button
              className="navbar-toggler"
              onClick={this.scrollToTop}
              role="button"
              aria-label="Scroll To Top"
            >
              <MdArrowUpward fontSize="4.5vh" color="white" />
            </Button>
          </NavItem>
        </Nav>
        <Nav className="navbar-nav ml-auto">
          <NavItem className="nav-item" style={{ display: "inline-block" }}>
            <Button
              className="navbar-toggler"
              onClick={this.props.toggleCollapse}
              role="button"
              aria-label="toggle filter and sorting menu"
            >
              <MdFilterList fontSize="4.5vh" color="white" />
            </Button>
          </NavItem>
        </Nav>
      </NavbarWithHeight>
    );
  }
}

export default connect()(NavbarSecond);
